import * as React from 'react';

/**
 * Different variants represent different application level layouts:
 *
 *  - The "left-aligned" variant is a layout with a left aligned navigation menu. This
 *    is traditionally used for applications with several levels of navigation.
 *
 *  - The "center-aligned" variant is a standard, horizontally centered application. This
 *    is a fairly conventional layout used for content  rich websites.
 */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This context is intended to allow information about the app
 * to be shared across various components at different levels of the tree.
 *
 * Generally speaking a single `<VarnishContext.Provider />` should be used
 * per page. More complex scenarios, however, might necessitate using multiple.
 */
export const VarnishContext = /*#__PURE__*/React.createContext({
  layout: 'center-aligned',
  currentHeaderHeight: 0,
  setHeaderHeight() {}
});
/**
 * A default, stateful wrapper that makes it easy to set app wide properties.
 *
 * Most of the time you should use this.
 */
export function DefaultAppLayoutProvider({
  layout,
  children
}) {
  const [currentHeaderHeight, setHeaderHeight] = React.useState(0);
  return React.useMemo(() => {
    return /*#__PURE__*/_jsx(VarnishContext.Provider, {
      value: {
        layout,
        currentHeaderHeight,
        setHeaderHeight
      },
      children: children
    });
  }, [layout, children, currentHeaderHeight]);
}
export default DefaultAppLayoutProvider;